module.exports = __webpack_public_path__ + "img/energyFetchExample.2be113e8.png";